﻿import Globe from 'globe.gl';
import * as THREE from 'three';

import './ts/memberprofile-map';

type institution = {
   name: string;
   title: string;
   lat: number;
   lng: number;
   alt: number;
   radius: number;
   url: string;
   color: string;
   size: number;
}

const init = () => {
   const globeContainer = document.getElementById('globeContainer') as HTMLDivElement;
   const locationsElms = document.querySelectorAll<HTMLElement>("[data-location='true']");
   const labels: institution[] = [];

   if (!globeContainer) {
      return;
   }

   locationsElms.forEach((l) => {
      if (!l.dataset.locationLat || !l.dataset.locationLng) {
         return;
      }
      const url =  l.getAttribute("href") ?? "";
      const i: institution = { name: l.innerText, title: l.innerText, url: url, radius: 0.5, alt: 0.00001, lat: Number.parseFloat(l.dataset.locationLat), lng: Number.parseFloat(l.dataset.locationLng), color: '#004982', size: 14 };
      labels.push(i);
      if (!l.dataset.otherlocations) {
         return;
      }
      const other = JSON.parse(l.dataset.otherlocations);
      other.forEach((o: any) => {
         const oi: institution = { name: o.name, title: o.name, url: url, radius: 0.5, alt: 0, lat: o.lat, lng: o.lng, color: '#ffcc00', size: 14 };
         labels.push(oi);
      });
   });


   const globe = new Globe(globeContainer, { rendererConfig: { antialias: false, precision: 'lowp' }, animateIn: false, waitForGlobeReady: true })
      //.globeImageUrl('/img/earth-night.jpg')
      .backgroundColor("#222222")
      .globeTileEngineUrl((x, y, l) => `https://tile.openstreetmap.org/${ l }/${ x }/${ y }.png`)
      .pointOfView({ lat: 39.6, lng: -18.5, altitude: 1.5 })
      .customLayerData(labels)
      .customThreeObject((d: any) => {
         const obj = new THREE.Mesh(
            new THREE.SphereGeometry(1),
            new THREE.MeshLambertMaterial({ color: d.color }));
         Object.assign(obj.position, globe.getCoords(d.lat, d.lng, d.alt));

         return obj;
      })
      .customThreeObjectUpdate((obj: any, d: any) => {
         Object.assign(obj.scale, new THREE.Vector3(d.radius, d.radius, d.radius));
      })
      .onCustomLayerClick((obj: any) => {
         window.open(obj.url, "_blank");
      });

   globeContainer.addEventListener("mouseenter", () => {
      globe.controls().autoRotate = false;
   });


   globeContainer.addEventListener("mouseleave", () => {
      if (globe.pointOfView().altitude > 0.6) {
         globe.controls().autoRotate = true;
      }
   });

   (function moveSpheres () {
      const pov: any = globe.pointOfView();
      labels.forEach(d => d.radius = Math.min( 0.001 + pov.altitude, 1));
      globe.customLayerData(globe.customLayerData());
      requestAnimationFrame(moveSpheres);
   })();

   globe.width(globeContainer.clientWidth);
   globe.height(globeContainer.clientHeight);

   globe.controls().autoRotate = true;
   globe.controls().autoRotateSpeed = 0.35;

   window.addEventListener('resize', (_event: Event) => {
      globe.width(globeContainer.clientWidth)
      globe.height(globeContainer.clientHeight)
   });
}

//document.addEventListener('CookieScriptCategory-functionality', init);
if (document.readyState === "loading") {
   // Loading hasn't finished yet
   document.addEventListener("DOMContentLoaded", init);
} else {
   // `DOMContentLoaded` has already fired
   init();
}